/*jshint unused:false*/
/*global fetch */
/*global console */



// $(function () {

// /**** NAV SCROLL ****/
//     $(".side-nav a, .header-intro a, .footer-content a").click(function(e){
//         e.preventDefault();
//         // Hide nav
//         // Scroll to location
//         $("html, body").animate({ 
//             scrollTop: $( $(this).attr('href') ).position().top+50
//         }, 600);
//     });

// });

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Price switch 
// function priceswitch(event) {
//     event.preventDefault();
//     document.getElementById('switch-price-type').value = this.value;
//     document.getElementById('price-switch').submit();
// }
// var price_buttons = document.querySelectorAll("#price-switch button");
// for(var i=0; i<price_buttons.length; i++){
//   price_buttons[i].addEventListener('click', priceswitch, false);
// }

// Car-Van Toggle
let moveVanBoxes = document.querySelectorAll('.deal-box-inner-van').forEach(((value, key) => {
  value.parentNode.parentNode.parentNode.querySelectorAll('.deal-box-dual')[key].append(value)
}))
let carSwitch = document.querySelectorAll('.car-toggle').forEach((value, key, parent) => {
  value.addEventListener('change', () => {
    parent[key].closest('.offers-strip').querySelectorAll('.deal-box').forEach((value) => {
      value.classList.toggle('show-van')
    })
  });
})

// Price toggles
let allSwitches = document.getElementById('price-switch');
let priceContainers = document.querySelectorAll('.deal-price-toggle');
// let priceSwitchForm = document.getElementById('price-switch');
let selected =0;
let switchType;
// allSwitches.forEach((value) => {
if (allSwitches) {
  allSwitches.addEventListener('change', (val) => {
    (allSwitches.nodeName === 'SELECT') ? switchType = 0 : switchType = 1;
    // (val.composedPath()[0].classList.contains('price-business')) ? selected = 0 : selected = 1;
    if (selected === 0) {
      val.composedPath()[0].classList.remove('price-business');
      val.composedPath()[0].classList.add('price-personal');
      selected = 1;
    } else {
      val.composedPath()[0].classList.remove('price-personal');
      val.composedPath()[0].classList.add('price-business');
      selected = 0;
    }

    // toggleSwitches();
    togglePrices();
    // updatePrice();
  })
}
// })
// let toggleSwitches = () => {
//   allSwitches.forEach((v) => {
//     (selected === 0) ? v.querySelector('.toggle-personal').checked = true : v.querySelector('.toggle-business').checked = true;
//   })
//   document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
// }
let togglePrices = () => {
  priceContainers.forEach((v) => {
    (selected === 0) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    (selected === 1) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
  })
}
// let updatePrice = () => {
//   let url = priceSwitchForm.getAttribute('action');
//   let formData = new FormData(priceSwitchForm);
//   fetch(url, {
//     method: 'POST',
//     processData: false,
//     contentType: false,
//     body: formData,
//     headers: {
//       'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
//       'X-Requested-With': 'XMLHttpRequest'
//     },
//   }).then(
//     function(response) {
//       if (response.status !== 200) {
//         console.log('Looks like there was a problem. Status Code: ' + response.status);
//         return;
//       }
//       response.json().then(function(data) {
//         document.querySelector("#price-switch [name=_token]").value = data.token;
//       });
//     }
//   ).catch(function(err) {
//     console.log('Fetch Error :-S', err);
//   });
// }
// End price Toggles

// Back to top button
// const scrollToTopButton = document.getElementById('back_to_top');
// smoothScrollCapture = (x) => {
//   event.preventDefault();
//   let id = x.currentTarget.target.getAttribute('href').split("#")[1]
//   let el = document.getElementById(id);
//   var x = el.getBoundingClientRect().left;
//   var y = el.getBoundingClientRect().top;
//   smoothScrollFunc(x, y)
// }
//
// smoothScrollFunc = (x, y) => {
//   event.preventDefault();
//   window.scrollTo({
//     top: y,
//     left: x,
//     behavior: 'smooth'
//   });
// }

// window.addEventListener('DOMContentLoaded', () => {
//   scrollToTopButton.addEventListener('click', () => {
//     smoothScrollFunc(0, 0);
//   })
// })

// window.addEventListener('scroll', () => {
//   let pageHeight = document.body.scrollHeight;
//   let currentHeight = window.scrollY;
//   (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
// })
// End back to top button

//Nav Toggle
function toggleNav(el) {
    var element = el;
    var menu = document.getElementById("site-menu");
    var header = document.querySelectorAll(".site-header")[0];
    menu.classList.toggle("active");
    header.classList.toggle("active");

    if(element.querySelector("span").classList.contains("more")){
      element.innerHTML = "<span class='close'></span> Close";
    } else {
      element.innerHTML = "<span class='more'></span> Menu";
    }
}

//Search Toggle
// function toggleSearch(el) {
//   var element = el;
//   var menu = document.getElementById("site-menu");
//   var header = document.querySelectorAll(".site-header")[0];
//   menu.classList.toggle("active");
//   header.classList.toggle("active");
// }

//Accordion active
// var showAccordion = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }
//
// var accordionButton = document.querySelectorAll(".accordion > button");
//
// for(var i=0; i<accordionButton.length; i++){
//   accordionButton[i].addEventListener('click', showAccordion, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('.hamburger');
// const hamburgerSearch = document.querySelector('.hamburger-search');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed'],
  onOpen: function() {
    // hamburgerSearch.classList.remove('is-active');
  },
  onClose: function () {
    // hamburgerSearch.blur();
  }
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);
// modalMobileNav.setFooterContent(document.querySelector('.top-bar-container').innerHTML);

// let searchOpened = false;
// const modalMobileSearch = new tingle.modal({
//   closeMethods: ['escape'],
//   cssClass: ['mobile-search','reversed'],
//   onOpen: function() {
//     hamburger.classList.remove('is-active');
//     this.setContent(document.querySelector('#headerSearch').innerHTML);
//     document.querySelector('#headerSearch').innerHTML = "";
//     loadSearchForm();
//     searchOpened = true;
//   },
//   onClose: function () {
//     hamburger.blur();
//     if (searchOpened) {
//       document.querySelector('#headerSearch').innerHTML = document.querySelector('.mobile-search .tingle-modal-box__content').innerHTML;
//       this.setContent('');
//       loadSearchForm();
//       searchOpened = false;
//     }
//   }
// });

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  if(hamburger.classList.contains("is-active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});

// Search modal
// const handleToggleSearch = () => {
//   hamburgerSearch.classList.toggle('is-active');
//
//   if(hamburgerSearch.classList.contains("is-active")) {
//     modalMobileNav.close();
//     modalMobileSearch.open();
//   } else{
//     modalMobileSearch.close();
//   }
// }
//
// hamburgerSearch.onclick = () => handleToggleSearch();
// hamburgerSearch.addEventListener('keyup', (event) => {
//   if(event.keyCode === 13 || event.keyCode === 32) {
//     handleToggleSearch();
//   }
// });

/* END MOBILE MODALS */

// Toggle search bar
  document.getElementById('toggle-search') ? document.getElementById('toggle-search').addEventListener('click', () => {document.querySelector('.search-bar').classList.toggle('active')}) : '';
// Toggle Advanced Search
// document.getElementById('advanced-search') ? document.getElementById('advanced-search').addEventListener('click', () => {document.querySelector('.search-bar').classList.toggle('search-advanced')}) : '';

// Toggle loader when searching
document.getElementById('search-button') ? document.getElementById('search-button').addEventListener('click', () => {document.body.classList.remove('loaded')}) : '';
// document.querySelector('.advanced-search-link') ? document.querySelector('.advanced-search-link').addEventListener('click', () => {document.body.classList.remove('loaded')}) : '';

// Search Bar
// var searchDropdown = function(){
//     var searchRow = this.closest('.search-bar');
//     searchRow.classList.toggle("active");
// }
//
// var searchBar = document.querySelectorAll(".search-bar .legend");
//
// for(var i=0; i<searchBar.length; i++){
//   searchBar[i].addEventListener('click', searchDropdown, false);
// }
//
//
// if(document.getElementsByClassName('toggle-search').length>0){
//     document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
//       e.preventDefault();
//       if(document.querySelector('#popout-form')===null){
//         window.location.href='/search';
//         return false;
//       }
//       if(document.querySelector('#popout-form').classList.contains('hidden')){
//         document.querySelector('#popout-form').classList.remove('hidden');
//       } else {
//         document.querySelector('#popout-form').classList.add('hidden');
//       }
//     });
// }



//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode;
//
//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         dropdown.classList.toggle("is-active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//           activeClass[i].classList.toggle("is-active");
//         }
//     }
//
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
//     dropdown.classList.toggle("is-active");
// }
//
// var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");
//
// for(var i=0; i<dropdownTrigger.length; i++){
//   dropdownTrigger[i].addEventListener('click', menuDropdown, false);
// }


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }
    
//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

//Terms Update
var termUpdate = function(sel){
    var select = sel;
    var form = document.getElementById('quick-search');

    if(select.value == "6-9"){
        form.action = "/short-term-6to9-months";
    } else if(select.value== "12-18"){
        form.action = "/short-term-12to18-months";
    } else{
        form.action = "/short-term-lease-offers";
    }
}

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}



//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }

  
//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }



//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

/**
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //change header text
  let headerSpan = document.getElementsByClassName("header-span");
  for (let i = 0; i < headerSpan.length; i++) {
    (searchType === 'car') ? headerSpan[i].innerHTML = 'Car Lease' : headerSpan[i].innerHTML = 'Van Lease';
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers((document.getElementsByClassName('search-van')[0].classList.contains('active') ? 'van' : 'car'));
  loadBodyTypes((document.getElementsByClassName('search-van')[0].classList.contains('active') ? 'van' : 'car'));

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers/available?';

    if(document.querySelector("[name=term]")&&document.querySelector("[name=term]").value!=''){
      url += '&term='+document.querySelector("[name=term]").value;
    }

    if(document.querySelector("[name=fuel_type]")&&document.querySelector("[name=fuel_type]").value!=''){
      url += '&fuel_type='+document.querySelector("[name=fuel_type]").value;
    }
    
    // // Set for electric if ev
    // $ev = false;
    // if(document.querySelector("[name=fuel_type]")){
    //   if(document.querySelector("[name=fuel_type]").value=='E'){
    //     $ev = true;
    //   }
    // }
    // if($ev){
    //   var url = '/api/'+$type+'/manufacturers/electric?available=yes';
    // }


    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let sortedEntries = Object.entries(data).sort(([, a], [, b]) => a.localeCompare(b));
      sortedEntries.forEach(([key, value]) => {
          let option = document.createElement('option');
          option.text = value;
          option.value = key;
          dropdown.add(option);
      });
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/models/'+$manufacturer+'/available?';

    if(document.querySelector("[name=term]")&&document.querySelector("[name=term]").value!=''){
      url += '&term='+document.querySelector("[name=term]").value;
    }

    if(document.querySelector("[name=fuel_type]")&&document.querySelector("[name=fuel_type]").value!=''){
      url += '&fuel_type='+document.querySelector("[name=fuel_type]").value;
    }

    // Set for electric if ev
    // $ev = false;
    // if(document.querySelector("[name=fuel_type]")){
    //   if(document.querySelector("[name=fuel_type]").value=='E'){
    //     $ev = true;
    //   }
    // }
    // if($ev){
    //   var url = '/api/'+$type+'/models/'+$manufacturer+'/electric?available=yes';
    // }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      for (var x in data) {
          var option = document.createElement('option');
          option.text = data[x];
          option.value = x;
          dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }

}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/specs/'+$model;

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });

}


function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    for (var x in data) {
        var option = document.createElement('option');
        option.text = data[x];
        option.value = x;
        dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}


//Lazy Load Images
document.addEventListener("DOMContentLoaded", function() {
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  //Contact Form
  if(document.getElementById('send-contact-form')){
    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.remove('loaded');

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.getElementsByName('email')[0].value;
          let name = document.getElementsByName('name')[0].value;
          let company = document.getElementsByName('company')[0].value;
          let telephone = document.getElementsByName('telephone')[0].value;
          let comments = document.getElementsByName('comments')[0].value;
          let token = document.getElementsByName('_token')[0].value;
          let recaptcha = document.querySelector('input[name=g-recaptcha-response]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'name': name, 'email': email, 'company': company, 'telephone': telephone, 'comments': comments, '_token': token, 'g-recaptcha-response': recaptcha }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status!='ok'){
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              return alert('There was a problem with your form\n\n'+errors);
            }

            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Contact Form Submit'
            });

            gtag_report_conversion(document.querySelector('#contact-form').dataset.url);

          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });
        });
      });
    });
  }

});

function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    // if(document.querySelectorAll('.search-form [name=make] option').length<=1){
      // loadBodyTypes('car'); //(document.getElementsByClassName('search-van')[0].classList.contains('active')?'van':
      loadManufacturers('car');
    // }
    document.querySelector('.search-form [name=term]').addEventListener("change", function(e){
      loadManufacturers(document.querySelector('.search-form [name=search-type]').value);
      loadModels(document.querySelector('.search-form [name=search-type]').value, document.querySelector('.search-form [name=make]').value);
    });

    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      loadModels(document.querySelector('.search-form [name=search-type]').value, e.target.value);
    });

    document.querySelector('.search-form [name=fuel_type]').addEventListener("change", function(e){
      loadManufacturers(document.querySelector('.search-form [name=search-type]').value);
      loadModels(document.querySelector('.search-form [name=search-type]').value, document.querySelector('.search-form [name=make]').value);
    });

    // document.querySelector('.search-form [name=fuel_type]').addEventListener("change", function(e){
    //   loadManufacturers(document.querySelector('.search-form [name=search-type]').value);
    // });

    document.querySelector('.search-form [name=search-type]').addEventListener("change", function(e){
      loadManufacturers(document.querySelector('.search-form [name=search-type]').value);
      loadModels(document.querySelector('.search-form [name=search-type]').value, document.querySelector('.search-form [name=make]').value);
    });

    // document.querySelector('.search-form [name=model]').addEventListener("change", function(e){
    //   loadSpecs('car', e.target.value);
    // });

    // document.getElementById('advanced-search').addEventListener('click',
    //   () => {document.querySelectorAll('.search-bar, .mobile-search').forEach((value) => {value.classList.toggle('search-advanced')})});
  }
}

setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 3000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader

  loadSearchForm();
});


// efficient debounce resize https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
var myEfficientFn = debounce(function() {
  if(window.innerWidth < 1024){
    //mobileDerrivative();
    mobileService();
    window.responsive = 'touch';
  } else {
    //desktopDerrivative();
    desktopService();
    window.responsive = 'desktop';
  }
}, 250);
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
window.addEventListener('resize', myEfficientFn);
myEfficientFn();


function mobileDerrivative(){
  if(window.responsive !== 'touch' && document.querySelector(".service-page-list")){
    if (document.querySelector(".move")) {
      document.querySelector(".deal-detail-ctr").appendChild(document.querySelector(".move"));
      document.querySelector(".move").classList.add('ctr');
    }
    if (document.querySelector(".deal-review")) {
      document.querySelector(".deal-full-details").appendChild(document.querySelector(".deal-review"));
    }
    //tabs
    // document.querySelectorAll(".tab")[0].after(document.getElementById("optional-extras"));
    // document.querySelectorAll(".tab")[1].after(document.getElementById("standard-equipment"));
    // document.querySelectorAll(".tab")[2].after(document.getElementById("technical-data"));

    // document.querySelector(".deal-gallery").after(document.querySelector(".deal-aside"));

    // tabcontent = document.querySelectorAll(".tab");
    // for (i = 0; i < tabcontent.length; i++) {
    //   tabcontent[i].className = tabcontent[i].className.replace(" active", "");
    // }
    // tablinks = document.querySelectorAll(".tab-content");
    // for (i = 0; i < tablinks.length; i++) {
    //   tablinks[i].className = tablinks[i].className.replace(" active", "");
    // }
  }
}

function mobileService(){
    if(window.responsive !== 'touch' && document.querySelector(".service-page-list")){
        // document.querySelector(".service-puff").appendChild(document.querySelector(".service-puff-list"));
        var service_puffs = document.querySelectorAll(".service-puff");

        for(var i=0; i<service_puffs.length; i++){
            service_puffs[i].appendChild(service_puffs[i].querySelector(".service-puff-list"));
        }
    }
}

function desktopDerrivative(){
  if(window.responsive !== 'desktop' &&  document.querySelector(".deal-gallery")){
    if (document.querySelector(".move")) {
        document.querySelector(".deal-main").appendChild(document.querySelector(".move"));
    }
    if (document.querySelector(".deal-review")) {
      // document.querySelector(".deal-info").appendChild(document.querySelector(".deal-review"));
      document.querySelector(".deal-info").insertBefore(document.querySelector(".deal-review"), document.querySelector(".deal-info .deal-spec"));
    }
    //tabs
    // document.querySelector(".deal-full-details").after(document.getElementById("technical-data"));
    // document.querySelector(".deal-full-details").after(document.getElementById("standard-equipment"));
    // document.querySelector(".tab-list").after(document.getElementById("optional-extras"));


    // document.querySelector(".deal-main").after(document.querySelector(".deal-aside"));

    // document.querySelectorAll(".tab")[0].classList.add("active");
    // document.querySelectorAll(".tab-content")[0].classList.add("active");
  }
}

function desktopService(){
    if(window.responsive !== 'desktop' &&  document.querySelector(".service-page-list")){
        // document.querySelector(".service-puff-content").appendChild(document.querySelector(".service-puff-list"));
        var service_desk_puffs = document.querySelectorAll(".service-puff");

        for(var i=0; i<service_desk_puffs.length; i++){
            service_desk_puffs[i].querySelector(".service-puff-content").appendChild(service_desk_puffs[i].querySelector(".service-puff-list"));
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
  // Hero fade
  // const heroContainer = document.querySelector('#full-header-background');
  // if(heroContainer){
  //   const sourceSet = heroContainer.getAttribute('data-source-set').split(', ').filter(url => url.length > 3);
  //   let currentSlide = 0;
  //
  //   function preloadImage(url) {
  //     (url) ? new Image().src = url : "";
  //   }
  //
  //   let heroFader = window.setInterval(function() {
  //     preloadImage(sourceSet[currentSlide+1]);
  //
  //     heroContainer.style.backgroundImage = `url('${sourceSet[currentSlide]}')`;
  //
  //     (currentSlide >= sourceSet.length-1) ? currentSlide = 0 : currentSlide += 1;
  //   }, 12000);
  // }
// End hero fade

  // Auto-slide helper function
  // function sliderAuto(slider, milliseconds) {
  //   const slidesCount = slider.track.childElementCount;
  //   let slideTimeout = null;
  //   let nextIndex = 1;
  //
  //   function slide() {
  //     slideTimeout = setTimeout(
  //       function () {
  //         if (nextIndex >= slidesCount ) {
  //           nextIndex = 0;
  //         }
  //         slider.scrollItem(nextIndex++);
  //       },
  //       milliseconds
  //     );
  //   }
  //
  //   slider.ele.addEventListener('glider-animated', function() {
  //     window.clearInterval(slideTimeout);
  //     slide();
  //   });
  //
  //   slide();
  // }

  // Manufacturers Slider
  // const manufacturersSlider = document.querySelector('.manufacturer-strip-ctr');
  // if (manufacturersSlider) {
  //   const gliderManufacturers = new Glider(manufacturersSlider, {
  //     slidesToScroll: 1,
  //     slidesToShow: 2.5,
  //     scrollLock: false,
  //     rewind: true,
  //     draggable: true,
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         settings: {
  //           slidesToShow: 4,
  //         }
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: {
  //           slidesToShow: 5,
  //         }
  //       }
  //     ]
  //   });
  //   sliderAuto(gliderManufacturers, 8000);
  // }

  // Deal Box Slider
  const dealBoxSlider = document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr')
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.offers-strip#'+sliderID+' .glider-prev',
          next: '.offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2.3,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3.3,
            }
          }
        ]
      })
    })
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

  // Google Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      arrows: {
        prev: '.reviews .glider-prev',
        next: '.reviews .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
    sliderAuto(glider, 8000);
  }


// Toggle class for accordions
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    // modalMobileSearch.close();
    // videoModal.close();
    // hamburgerSearch.classList.remove('is-active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
  }, false);

  // Table Sorting
  function sortTable(elem) {
    let sortName = elem.composedPath()[0].dataset.sortname;
    let sortDirection = elem.composedPath()[0].dataset.sortdirection;
    let tableBody = elem.composedPath()[3].childNodes[3];
    let tableRows = Array.from(tableBody.children);

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      document.querySelectorAll('.table-sort').forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      document.querySelectorAll('.table-sort').forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  // Manufacturer Header 'Read More'
  let manufacturerHeaderContent = document.querySelector('#manufacturer-header-content');
  let manufacturerHeaderButton = document.querySelector('#manufacturer-more-button');

  if (manufacturerHeaderContent) {
    (manufacturerHeaderContent.clientHeight > 199) ? manufacturerHeaderButton.classList.remove('visuallyhidden') : '';
    manufacturerHeaderButton.addEventListener('click', () => {
      manufacturerHeaderContent.classList.add('active');
      manufacturerHeaderButton.classList.add('visuallyhidden');
    })
  }

// Model Table Search
//   let allRows = document.querySelectorAll('.model-table-body > .model-table-wrapper');
//   let filterFields = document.querySelectorAll('.filters-form select');
//   let searchField = document.querySelector('#filter-derivative');
//   let body_types = [];
//   let transmission_types = [];
//   let fuel_types = [];
//   const loadOptions = () => {
//     allRows.forEach((row) => {
//       (row.getAttribute('data-bodytype')) ? body_types.push(row.getAttribute('data-bodytype')) : '';
//       body_types = [...new Set(body_types)];
//       (row.getAttribute('data-gearbox')) ? transmission_types.push(row.getAttribute('data-gearbox')) : '';
//       transmission_types = [...new Set(transmission_types)];
//       (row.getAttribute('data-fuel')) ? fuel_types.push(row.getAttribute('data-fuel')) : '';
//       fuel_types = [...new Set(fuel_types)];
//     })
//     const loadSelectOptions = (type, array) => {
//       array.forEach((v) => {
//         let option = document.createElement("option");
//         option.value = v;
//         option.text = v;
//         document.querySelector('select[name=' + type + ']').appendChild(option);
//         fuel_types = [];
//       })
//     }
//     loadSelectOptions('fuel_types', fuel_types);
//     loadSelectOptions('body_types', body_types);
//     loadSelectOptions('transmission_types', transmission_types);
//   }
//
//   const filterTable = (field, value) => {
//     let searchType;
//     if (field === 'fuel_types') {
//       searchType = 'fuel';
//     } else if (field === 'transmission_types') {
//       searchType = 'gearbox';
//     } else if (field === 'body_types') {
//       searchType = 'bodytype';
//     } else {
//       searchType = field;
//     }
//
//     if (value !== 'Any' && value.length > 0) {
//       let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');
//       elements.forEach((v, i) => {
//         v.classList.add('hidden-' + field + '')
//         if(v.getAttribute('data-' + searchType + '').includes(value)) {
//           v.classList.remove('hidden-' + field + '')
//         }
//       })
//     } else {
//       document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
//         v.classList.remove('hidden-' + field + '')
//       });
//     }
//
//     // Show no results text
//     if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
//       document.querySelector('.no-results').classList.remove('hidden-no-results');
//     } else {
//       document.querySelector('.no-results').classList.add('hidden-no-results');
//     }
//
//     // Fix rows background
//     document.querySelectorAll('.model-table-wrapper:not([class*="hidden"])').forEach((v, i) => {
//       v.classList.remove('even')
//       if (i % 2 !== 0) {
//         v.classList.add('even')
//       }
//     });
//   }
//
//  if (searchField) {
//    loadOptions();
//    filterFields.forEach((value => {
//      value.addEventListener('change', (event) => {
//        let val = value.value;
//        let field = value.getAttribute('name');
//        filterTable(field, val);
//      })
//    }))
//    searchField.addEventListener('input', (event) => {
//      filterTable('variant', event.target.value);
//    })
//  }
// End Model Table Search
});
